import AvailabilityVisibility from '../Payment/RebookAppointment/AvailabilityVisibility';
import SlotSelector from '../Payment/RebookAppointment/SlotSelector';

export default function DateSelect({
  selectedDate,
  setSelectedDate,
  selectedGroomer,
}) {
  return (
    <div className="date-select-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-12">Choose a time</h4>
      <SlotSelector
        selectedTimeSlot={selectedDate}
        setSelectedTimeSlot={setSelectedDate}
      />
      <AvailabilityVisibility
        selectedDate={selectedDate}
        selectedGroomer={selectedGroomer}
        className="mt-12"
      />
    </div>
  );
}
